import axios from 'axios';

import { env } from 'config';
import { UserRole } from 'enums';
import { ShopGroup } from 'types';

import { createCrudApi } from './crud.api';

const url = `${env.apiUrl}/shop-group`;

const addShopAsRole =
  (role: UserRole) =>
  async (groupId: string, shopId: string): Promise<void> => {
    await axios.post(`${url}/${role}/${groupId}/shops/${shopId}`);
  };

const removeShopAsRole =
  (role: UserRole) =>
  async (groupId: string, shopId: string): Promise<void> => {
    await axios.delete(`${url}/${role}/${groupId}/shops/${shopId}`);
  };

export const shopGroupsApi = {
  ...createCrudApi<ShopGroup>('/shop-group'),
  addShopAsRole,
  removeShopAsRole,
};
